import { render } from "./PaymentResult.vue?vue&type=template&id=17e00785&scoped=true"
import script from "./PaymentResult.vue?vue&type=script&lang=js"
export * from "./PaymentResult.vue?vue&type=script&lang=js"

import "./PaymentResult.vue?vue&type=style&index=0&id=17e00785&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17e00785"]])

export default __exports__